module.exports = __webpack_public_path__ + "img/symbol_6.c388e629.png";